import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export function isLocalBootAvailable(): boolean {
    return isGlobalFeatureEnabled('fwk-local-boot');
}
